import React, { Component } from "react";
import Translations from "../../../../services/translation.service";
import OperatorsSelect from "../../../shared/operators-select.component";
import mnpNumberContext from "../../../../context/MNP_Number";
import StorefrontTitle from "../../../shared/storefront-title.component";
import hint from "../../../../assets/img/hint.svg";
import Settings from '../../../../services/settings.service';
import Helpers from "../../../../helpers/shared.helper";
import PhoneWrapper from "../../../shared/sharedFields/phoneWrapper";
import FirebaseAnalytics from "../../../../services/analytics.service";

export default class MNPForm extends Component {
  state = {
    form: null,
    loading: true,
    // validity: false
  };

  fields = {
    operator_id: {
      default: "",
      value: "",
      type: "text",
      required: true,
    },
    mnp_number: {
      default: "",
      value: "",
      type: "text", // phone
      required: true,
      country: "SA",
    },
    contact_number: {
      default: "",
      value: "",
      type: "text", // phone
      required: false,
      dependency: "selected_country_contact",
    },
    selected_country_contact: {
      default: "SA",
      value: "SA",
      type: "country",
      required: true,
      dependent: "contact_number",
    },
  };

  componentDidMount(){
    this.commonRecordFirebaseEvent({
      event_label: "landing",
      interaction_type: "view"
    })
  }

  inputDigits = (event, limit = 14) => {
    const re = /^[0-9\b]+$/;
    return (
      event.target.value === "" ||
      (event.target.value.length <= limit && re.test(event.target.value))
    );
  };

  commonRecordFirebaseEvent = ({ event_label = "", interaction_type = "", ...properties }) => {
    const event_params = {
      event_category: "onboarding_mnp",
      event_screen: "onboarding_mnp_form",
      event_label,
      interaction_type,
      ...properties
    }
    FirebaseAnalytics.commonFunction(event_params)
  }

  render() {
    let content = "";
    let prefix = "scr_17.0_MNP_form_";
    let legal_link = Settings.legal_link;
      legal_link = legal_link.replace("%lang%", Translations.activeLang);

    let fields = (
      <>
        <StorefrontTitle
          title={Translations.keys[prefix + "title"]}
          desc={Translations.keys[prefix + "desc"]}
        />
        <mnpNumberContext.Consumer>
          {(context) => {
            return (
              <div className="field-container">
                <label>{Translations.keys[prefix + "mobile_number"]}</label>
                <input
                  type="tel"
                  name="mnp_number"
                  id="mnp_number"
                  value={this.props.state.mnp_number.value}
                  className={`storefront-search-input ${(!this.props.state.mnp_number.tuched || (this.props.state.mnp_number.tuched && this.props.state.mnp_number.validation)) ? "": "error"}`}
                  placeholder={Translations.keys["scr_17.0_MNP_form_mob_num_placeholder"] || "Ex. +966 123 456"}
                  onChange={(event) => {
                    if (this.inputDigits(event)) {
                      this.props.updateFieled(event, "form", "phone");
                      context.updateMnpNumber(event.target.value);
                    }
                  }}
                />
                <div className="hint-section">
                  <img src={hint} alt="hint" />
                  <p>{Translations.keys[prefix + "hint"]}</p>
                </div>
              </div>
            );
          }}
        </mnpNumberContext.Consumer>
        <OperatorsSelect
          form_id={"operator_id"}
          label={Translations.keys["scr_17.0_MNP_form_tab_select_operator"]}
          default={this.props.state.operator_id.value}
          field_name="operator_id"
          updateFieled={this.props.updateFieled}
        />
        <div className="field-container">
          <label>{Translations.keys["scr_17.0_MNP_form_contact_num_label"] || "Contact Number"}</label>
          <PhoneWrapper>
            <input
              type="tel"
              name="contact_number"
              id="contact_number"
              className={`storefront-search-input ${(!this.props.state.contact_number.tuched || (this.props.state.contact_number.tuched && this.props.state.contact_number.validation)) ? "": "error"}`}
              placeholder={Translations.keys[prefix + "contact_number"]}
              value={this.props.state.contact_number.value}
              onChange={(event) => {
                if (this.inputDigits(event, 9)) {
                  this.props.updateFieled(event, "form", "phone");
                }
              }}
            />
          </PhoneWrapper>
        </div>
        <div className="bottom-section">
          <p className="please-confirm-text">{Translations.keys[prefix + "please_confirm"]}</p>
          <div className={`checkbox-container storefront-checkbox ${Helpers.isSafari() ? "safari" : ""}`}>
            <input type="checkbox" name="validId" checked ={this.props.state.validId.value} onChange={(event)=>{
              this.props.updateFieled(event, "form", "checkbox");
            }}/>
            <label>{Translations.keys[prefix + "valid_text"]}</label>
          </div>
          <div className={`checkbox-container storefront-checkbox ${Helpers.isSafari() ? "safari" : ""}`}>
            <input type="checkbox" name="terms" checked ={this.props.state.terms.value} onChange={(event)=>{
              this.props.updateFieled(event, "form", "checkbox");
            }}/>
            <label>
            {Translations.keys[prefix + "read_and_agree"]}{" "}
              <span>
              <a href={legal_link} target="_blank" rel="noopener noreferrer">
                {Translations.keys[prefix + "legal_stuff"]}
                </a>
                </span>
            </label>
          </div>
        </div>
      </>
    );

    content = (
      <div className="bring-number-card-container">
        {fields}
        <button
          className={`common-button ${!this.props.state.formValid ? "diabled": ""}`}
          // disabled={!this.props.state.formValid}
          onClick={() => {
            this.commonRecordFirebaseEvent({
              event_label: "next",
              interaction_type: "click",
              mnp_number: this.props.state?.mnp_number?.value || "",
              operator_name: this.props.state?.operator_id.value || "",
              legal_stuff: this.props.state?.terms?.value || "",
              mnp_status: this.props.state?.validId?.value || "",
              contact_number: this.props.state?.contact_number?.value || "",
            });
            this.props.submit();
          }}
        >
          {Translations.keys["17.2_B_MNP_Status_continue"]}
        </button>
      </div>
    );
    return content;
  }
}
